import BaseService from "core/framework/BaseService";
import { getLogger } from "core/utils";

const log = getLogger("BaseExternalRequestService");

export default class BaseExternalRequestService extends BaseService {
  constructor({ baseUrl }) {
    super();

    if (!baseUrl) {
      throw Error("Missing parameter: baseUrl");
    }

    this.baseUrl = baseUrl;
  }

  async insert({ instance }) {
    if (!instance) {
      log.error("Missing parameter: instance");
      throw Error("Missing parameter: instance");
    }

    log.debug("Inserting ", instance);

    return await this.post({
      url: this.baseUrl,
      data: instance
    });
  }
}
